import HealthSummarySection from "@/components/health-summary";


export default function HealthSummary() {
  return <HealthSummarySection />;
}
